var customTags = {
	currentYear: { label: "Current Year", id: "currentYear['y']", value: "2023" },
	currentMonth: {
		label: "Current Month",
		id: "currentMonth['m']",
		value: "07",
	},
	currentDay: { label: "Current Day", id: "currentDay['d']", value: "01" },
	currentDate: {
		label: "Current Date",
		id: "currentDate['d-m-Y']",
		value: "01-01-2023",
	},
	currentTime: {
		label: "Current Time",
		id: "currentTime['h:i:sa']",
		value: "06:00:00:am",
	},
	postPublishDate: {
		label: "Post Publish Date",
		id: "postPublishDate['d-m-Y']",
		value: "01-01-2023",
	},
	postModifiedDate: {
		label: "Post Modified Date",
		id: "postModifiedDate['d-m-Y']",
		value: "01-01-2023",
	},
	termId: { label: "Term Id", id: "termId", value: "123" },
	termTitle: {
		label: "Term Title",
		id: "termTitle",
		value: "Hello Term Title",
	},
	termDescription: {
		label: "Term Description",
		id: "termDescription",
		value: "Hello term description",
	},
	termPostCount: {
		label: "Term Post Count",
		id: "termPostCount",
		value: "123",
	},
	postTagTitle: {
		label: "Post Tag Title",
		id: "postTagTitle",
		value: "sports",
	},
	postTagsTitle: {
		label: "Post Tags Title",
		id: "postTagsTitle['3,-']",
		value: "football , cricket",
	},
	postCategoryTitle: {
		label: "Post Category Title",
		id: "postCategoryTitle",
		value: "sports",
	},
	postCategoriesTitle: {
		label: "Post Categories Title",
		id: "postCategoriesTitle['3']",
		value: "football , cricket",
	},
	postTermTitle: {
		label: "Post Term Title",
		id: "postTermTitle['taxonomy']",
		value: "sports",
	},
	postTermsTitle: {
		label: "Post Terms Title",
		id: "postTermsTitle['taxonomy,3']",
		value: "football , cricket",
	},
	postSlug: { label: "Post Slug", id: "postSlug", value: "post-slug" },
	postId: { label: "Post ID", id: "postID", value: "123" },
	postStatus: { label: "Post Status", id: "postStatus", value: "published" },
	authorId: { label: "Author Id", id: "authorId", value: "123" },
	authorName: { label: "Author Name", id: "authorName", value: "hello author" },
	authorFirstName: {
		label: "Author FirstName",
		id: "authorFirstName",
		value: "first name",
	},
	authorLastName: {
		label: "Author Last Name",
		id: "authorLastName",
		value: "last name",
	},
	authorDescription: {
		label: "Author Description",
		id: "authorDescription",
		value: "Hello author description",
	},
	excerpt: { label: "Post Excerpt", id: "excerpt", value: "hello excerpt" },
	rankmathTitle: { label: "Rankmath Title", id: "rankmathTitle", value: "Rank Math Title" },
	// rankmathPermalink: {
	// 	label: "Rankmath Permalink",
	// 	id: "rankmathPermalink",
	// 	value: "",
	// },
	rankmathDescription: {
		label: "Rankmath Description",
		id: "rankmathDescription",
		value: "Rank Math Description",
	},
	rankmathFocusKeyword: {
		label: "Rankmath Focus Keyword",
		id: "rankmathFocusKeyword",
		value: "Rank Math Focus Keyword",
	},
	// rankmathFocusKeywords: {
	// 	label: "Rankmath Focus Keywords",
	// 	id: "rankmathFocusKeywords[', ']",
	// 	value: "",
	// },
	rankmathOrgname: {
		label: "Rankmath Org name",
		id: "rankmathOrgname",
		value: "Rank Math Org Name",
	},
	rankmathOrgurl: {
		label: "Rankmath Org URL",
		id: "rankmathOrgurl",
		value: "https://hello.world",
	},
	rankmathOrglogo: {
		label: "Rankmath Org logo",
		id: "rankmathOrglogo",
		value: "",
	},
	siteTitle: { label: "Site Title", id: "siteTitle", value: "WordPress" },
	siteDescription: {
		label: "Site Description",
		id: "siteDescription",
		value: "Hello site description",
	},
	// siteTagline: { label: "Site Tagline", id: "siteTagline", value: "" },
	postMeta: { label: "Post Meta", id: "postMeta['metaKey']", value: "meta value" },
	separator: { label: "Separator", id: "separator['-']", value: "-" },
	searchTerms: { label: "Search Terms", id: "searchTerms", value: "hello search terms" },
	// counter: { label: "Counter", id: "counter", value: "" },
};

export default customTags;
